module.exports = __webpack_public_path__ + "assets/d7673f055468194219bdaaa54c35e5f6.svg";